import { render, staticRenderFns } from "./paymentDialog.vue?vue&type=template&id=2bd83554&scoped=true&"
import script from "./paymentDialog.vue?vue&type=script&lang=ts&"
export * from "./paymentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./paymentDialog.vue?vue&type=style&index=0&id=2bd83554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd83554",
  null
  
)

export default component.exports